module.exports = __webpack_public_path__ + "img/Cargo-bike-right-side.442ea3a.svg";